// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"3fc224e9","346":"f26d41ea","762":"a27a5cc9","764":"156bd6e4"}[chunkId] + ".chunk.js";
};